import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { match } from 'ts-pattern';

export enum CreationStep {
  CreateNotice = 'create',
  Summary = 'summary',
  Completion = 'complete',
}

export const useCreationStep = (dataIsValid?: boolean) => {
  const { search, pathname } = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(search);

  const rawStepFromParams = params.get('step');

  const setStep = (step: CreationStep) => {
    const params = new URLSearchParams(search);
    params.set('step', String(step));

    history.replace(`${pathname}?${params.toString()}`);
  };

  const validStepFromParams = match(rawStepFromParams)
    .with(CreationStep.Completion, CreationStep.Summary, (step) =>
      dataIsValid ? step : CreationStep.CreateNotice,
    )
    .otherwise(() => CreationStep.CreateNotice);

  useEffect(() => {
    if (rawStepFromParams !== validStepFromParams) {
      setStep(validStepFromParams);
    }
  }, [validStepFromParams]);

  return {
    step: validStepFromParams,
    setStep,
  };
};
